import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import JournalEntryIndexPage from '../containers/JournalEntries'
import JournalEntryShowPage from '../containers/JournalEntries/show'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const JournalEntriesPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'journal_entries') {
			dispatch(changeCurrent(['journal_entries']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={JournalEntryIndexPage} exact />
      <Route path={`${path}/:date`} component={JournalEntryShowPage} />
		</Switch>
  )
}

JournalEntriesPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

JournalEntriesPage.defaultProps = {}

export default JournalEntriesPage
